import React from 'react'
import { Link } from 'react-scroll'

const ExpandedMenu = ({ onClose, offset }) =>
  <div className="fixed top-0 right-0 left-0 bottom-0 bg-red z1 white">
    <div className="header__close-btn absolute pointer fw2 f1" onClick={onClose}>×</div>
    <div className="header__menu-items flex flex-column tc fw3 f5 mt6">
      <Link className="mb4" to="press" onClick={onClose} offset={-offset}>In the Media</Link>
      <Link className="mb4" to="areas" onClick={onClose} offset={-offset}>Areas of Practice & Testimonials</Link>
      <Link className="mb4" to="about" onClick={onClose} offset={-offset}>About</Link>
      <Link className="mb4" to="contact" onClick={onClose} offset={-offset}>Contact</Link>
      <a href="https://medium.com/">Blog</a>
    </div>
  </div>

export default ExpandedMenu



// WEBPACK FOOTER //
// ./src/components/header/expanded-menu.js